var _g, _path, _rect, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClusterPoint2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 28,
    viewBox: "0 0 100 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 3,
    width: 92,
    height: 20,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 3.5,
    width: 91,
    height: 19,
    rx: 9.5,
    stroke: "#1E88E5"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58 13C58 12.2637 57.5371 11.6348 56.8848 11.3906C57.1719 10.7578 57.0566 9.98633 56.5352 9.46484C56.0137 8.94336 55.2422 8.82812 54.6094 9.11523C54.3652 8.46289 53.7363 8 53 8C52.2637 8 51.6348 8.46289 51.3906 9.11523C50.7578 8.82812 49.9844 8.94336 49.4648 9.46484C48.9434 9.98633 48.8281 10.7578 49.1152 11.3906C48.4629 11.6348 48 12.2637 48 13C48 13.7363 48.4629 14.3652 49.1152 14.6094C48.8281 15.2422 48.9434 16.0156 49.4648 16.5352C49.9844 17.0547 50.7559 17.1738 51.3906 16.8848C51.6348 17.5352 52.2637 18 53 18C53.7363 18 54.3652 17.5371 54.6094 16.8848C55.2461 17.1738 56.0156 17.0547 56.5352 16.5352C57.0566 16.0137 57.1719 15.2422 56.8848 14.6094C57.5371 14.3652 58 13.7363 58 13ZM53.4688 14.8445V15.1875C53.4688 15.3602 53.3289 15.5 53.1562 15.5H52.8438C52.6711 15.5 52.5312 15.3602 52.5312 15.1875V14.8412C52.3082 14.8148 52.0961 14.7398 51.9105 14.6174C51.7891 14.5371 51.7773 14.3613 51.8803 14.2584L52.2225 13.9162C52.2955 13.8432 52.4043 13.8334 52.498 13.8766C52.5602 13.9051 52.6281 13.9199 52.6984 13.9199H53.3387C53.4297 13.9199 53.5035 13.8461 53.5035 13.7555C53.5035 13.6822 53.4543 13.6172 53.384 13.5971L52.4061 13.3178C51.9715 13.1937 51.6246 12.8352 51.568 12.3867C51.4889 11.7604 51.9396 11.226 52.5312 11.1553V10.8125C52.5312 10.6398 52.6711 10.5 52.8438 10.5H53.1562C53.3289 10.5 53.4688 10.6398 53.4688 10.8125V11.1588C53.6918 11.1852 53.9039 11.2602 54.0895 11.3826C54.2109 11.4629 54.2227 11.6387 54.1197 11.7416L53.7775 12.0838C53.7045 12.1568 53.5957 12.1666 53.502 12.1234C53.4391 12.0947 53.3707 12.0799 53.3016 12.0801H52.6613C52.5703 12.0801 52.4965 12.1539 52.4965 12.2445C52.4965 12.3178 52.5457 12.3828 52.616 12.4029L53.5939 12.6822C54.0285 12.8064 54.3754 13.1648 54.432 13.6133C54.5111 14.2395 54.0604 14.7738 53.4688 14.8445Z",
    fill: "#1E88E5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 3,
    width: 40,
    height: 20,
    rx: 10,
    fill: "#1E88E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9997 15.0006H10.9994V12.5003H9.99929V16.5007C9.99929 16.7773 10.2228 17.0008 10.4993 17.0008H14.4997C14.7763 17.0008 14.9998 16.7773 14.9998 16.5007V12.5003H13.9997V15.0006ZM18.9158 11.2221L17.5828 9.2219C17.4891 9.08282 17.3328 9 17.1656 9H10.8337C10.6665 9 10.5103 9.08282 10.4181 9.2219L9.08515 11.2221C8.86325 11.5549 9.10077 12.0003 9.50081 12.0003H18.5001C18.8986 12.0003 19.1361 11.5549 18.9158 11.2221ZM17 16.7507C17 16.8882 17.1125 17.0008 17.25 17.0008H17.75C17.8875 17.0008 18.0001 16.8882 18.0001 16.7507V12.5003H17V16.7507Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 100,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClusterPoint2);
export default __webpack_public_path__ + "static/media/cluster_point-2.299e528eaa0a47582aea52f3bc76e917.svg";
export { ForwardRef as ReactComponent };